/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getOverviewCombined } from "../fn/overview/get-overview-combined";
import { GetOverviewCombined$Params } from "../fn/overview/get-overview-combined";
import { listNames } from "../fn/overview/list-names";
import { ListNames$Params } from "../fn/overview/list-names";
import { DomainZone } from "../models/domain-zone";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class OverviewService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOverviewCombined()` */
  static readonly GetOverviewCombinedPath = "/surfdomeinen/organisations/{organisation_id}/overview/combined";

  /**
   * Get Overview Combined.
   *
   * Combined list of all zones and domains
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverviewCombined()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewCombined$Response(
    params: GetOverviewCombined$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<DomainZone>>> {
    const obs = getOverviewCombined(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Overview Combined.
   *
   * Combined list of all zones and domains
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOverviewCombined$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverviewCombined(params: GetOverviewCombined$Params, context?: HttpContext): Observable<Array<DomainZone>> {
    const resp = this.getOverviewCombined$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<Array<DomainZone>>): Array<DomainZone> => r.body));
  }

  /** Path part for operation `listNames()` */
  static readonly ListNamesPath = "/surfdomeinen/organisations/{organisation_id}/overview/list";

  /**
   * List Names.
   *
   * Get a list of successfully registered domain names and zone names for the given organisation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listNames()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNames$Response(params: ListNames$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    const obs = listNames(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List Names.
   *
   * Get a list of successfully registered domain names and zone names for the given organisation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listNames$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNames(params: ListNames$Params, context?: HttpContext): Observable<any> {
    const resp = this.listNames$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }
}
